<template>
  <FeaturesSection
    :features="apiFeatures"
    tag="Features"
    title="Easy-to-use APIs"
    description="LayUp integrates at any level bringing an unparalleled recurring payments solution for business."
    hasButton
    :use-alternative-tag-text-color="useAlternativeTagTextColor"
    :items-per-row="itemsPerRow"
    :add-padding-x="addPaddingX"
  />
</template>

<script setup lang="ts">
import type { Feature } from './FeaturesSection.vue';
import FeaturesSection from './FeaturesSection.vue';
import IntersectSquare from '@/assets/images/intersect-square.svg'
import PieChart from '@/assets/images/pie-chart.svg'

interface Props {
  useAlternativeTagTextColor?: boolean;
  itemsPerRow?: number;
  addPaddingX?: boolean;
}
const { useAlternativeTagTextColor = false, itemsPerRow, addPaddingX } = defineProps<Props>();

const apiFeatures = [
  {
    image: IntersectSquare,
    title: 'Pre-built integrations',
    description: 'Connect LayUp to your business software to enjoy seamless and secure transactions.',
    buttonStyle: 'link-light' as Feature['buttonStyle'],
    buttonLink: '/business/plugins',
  },
  {
    icon: 'Smile',
    title: 'API documentation',
    description: 'We help you simplify and automate processes, leaving time to focus on acquisition and growth.',
    buttonLabel: 'View documentation',
    buttonStyle: 'link-light' as Feature['buttonStyle'],
    buttonLink: 'https://documentation.layup.co.za/',
    buttonFontColor: 'text-grey-dark-300'
  },
  {
    image: PieChart,
    title: 'Point of sale',
    description: 'Process transactions, accept payments from customers and keep track of sales efficiently.',
    buttonLabel: 'Find out more',
    buttonStyle: 'link-light' as Feature['buttonStyle'],
    buttonLink: '/business',
    buttonFontColor: 'text-grey-dark-300'
  },
];
</script>
